import React, { ChangeEvent, useState } from "react";
import "./FileUpload.scss";
import { IoCloudUpload } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { Button } from "primereact/button";

export default function FileUpload({ handleChange }: { handleChange: any }) {
  const [files, setFiles] = useState<File[]>([]);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = Array.from(event.target.files || []);
    const totalFiles = files.concat(selectedFiles);
    setFiles(totalFiles);
    handleChange(totalFiles);
  };

  const handleFileRemove = (index: number) => {
    const pdfFiles = files.filter((_, i) => i !== index);
    setFiles(pdfFiles);
    handleChange(pdfFiles);
  };

  return (
    <div className="file-upload">
      <label className="upload-icon" htmlFor="file-upload">
        <IoCloudUpload />
        <div>
          <p>
            <strong>Click to upload files.</strong>
          </p>
          <p>Limit 200MB in total • csv, doc, docx, pdf, ppt, pptx, xlsx</p>
        </div>
      </label>

      <input
        id="file-upload"
        type="file"
        accept=".csv,.doc,.docx,.pdf,.ppt,.pptx,.xlsx"
        multiple
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <div className="file-list">
        {files.length > 0 && (
          <ul>
            {files.map((file, index) => (
              <li key={index}>
                <p>
                  {file.name} - {(file.size / 1024).toFixed(2)} KB
                </p>
                <Button onClick={() => handleFileRemove(index)}>
                  <MdDeleteOutline />
                </Button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
